const choices = new Map();
class WotobeusProtector extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.form = this.closest('form');
    this.select = this.querySelector('[data-protector-choice]');
    this.models = JSON.parse(this.querySelector('[data-protector-models]').textContent);
    this.select.value = choices.get(this.dataset.productId) || '';
    this.form?.addEventListener('change', () => this.sync(), {signal: this.controller.signal});
    this.form?.addEventListener('input', () => this.sync(), {signal: this.controller.signal});
    this.form?.addEventListener('pointerdown', () => this.sync(), {capture: true, signal: this.controller.signal});
    this.sync();
  }
  disconnectedCallback() { this.controller?.abort(); }
  sync() {
    const id = this.form?.querySelector('[name="id"]')?.value;
    const quantity = Math.max(1, Number(this.form?.querySelector('[name="quantity"]')?.value) || 1);
    const option = this.select?.selectedOptions[0];
    const enabled = Boolean(this.select?.value);
    const model = this.form?.querySelector('[name=\"properties[Telefon Modeli]\"]')?.value || this.models?.[id]?.model || '';
    choices.set(this.dataset.productId, this.select.value);
    const values = {id: this.select.value, parent: id || '', quantity: String(quantity), model};
    for (const input of this.querySelectorAll('[data-protector-field]')) {
      input.disabled = !enabled;
      const key = input.dataset.protectorField;
      if (key in values) input.value = values[key];
    }
    const total = this.querySelector('[data-protector-total]');
    total.hidden = !enabled;
    const price = (this.models?.[id]?.price || 0) + Number(option?.dataset.price || 0);
    total.textContent = 'Kılıf + ekran koruyucu: ' + new Intl.NumberFormat('tr-TR', {style:'currency', currency:'TRY'}).format(price / 100) + (quantity > 1 ? ' / adet' : '');
  }
}
if (!customElements.get('wotobeus-protector')) customElements.define('wotobeus-protector', WotobeusProtector);

